// extracted by mini-css-extract-plugin
export default {"bg":"style_bg__BZVix"};